import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import t, { getLocale } from '@zenlayer/zen-intl18';
import { getProductInfoForAlias } from "../function/getProductInfo";

/**
 * 获取console系统品牌(Zenlayer Console)
 * @function
 * @return {string}
 */
export var getTitle = function getTitle() {
  try {
    return window._console_info.consoleBranding.consoleName;
  } catch (e) {
    return 'Console';
  }
};
/**
 * 获取console网站图标path
 * @function
 */

export var getFaviconPath = function getFaviconPath() {
  try {
    return window._console_info.consoleBranding.faviconUrl;
  } catch (e) {
    return '';
  }
};
/**
 * 获取light模式下网站logo path
 * @function
 */

export var getLightLogoPath = function getLightLogoPath() {
  try {
    return window._console_info.consoleBranding.logoUrl_light;
  } catch (e) {
    return '';
  }
};
/**
 * 获取dark模式下网站logo path
 * @function
 */

export var getDarkLogoPath = function getDarkLogoPath() {
  try {
    return window._console_info.consoleBranding.logoUrl_dark;
  } catch (e) {
    return '';
  }
};
/**
 * 判断是否为defaultPartner
 * @function
 */

export var getIsDefaultPartner = function getIsDefaultPartner() {
  try {
    return window._console_info.partnerCode === 'DEFAULT';
  } catch (e) {
    return false;
  }
};
/**
 * 判断是否为TelinPartner
 * @function
 */

export var getIsTelinPartner = function getIsTelinPartner() {
  try {
    return window._console_info.partnerCode === 'telin';
  } catch (e) {
    return false;
  }
};
/**
 * 判断是否为ChiefPartner
 * @function
 */

export var getIsChiefPartner = function getIsChiefPartner() {
  try {
    return window._console_info.partnerCode === 'chief';
  } catch (e) {
    return false;
  }
};
/**
 * 检查时否为员工账号
 * @param email
 * @returns
 */

export var getIsStuffEmail = function getIsStuffEmail(email) {
  return /@zenlayer.com$/.test(email);
};
/**
 * 判断是否为HarmonyPartner
 * @function
 */

export var getIsHarmonyPartner = function getIsHarmonyPartner() {
  try {
    return window._console_info.partnerCode === 'harmony';
  } catch (e) {
    return false;
  }
};
/**
 * 获取partner身份
 * @function
 */

export var getPartnerCode = function getPartnerCode() {
  try {
    return window._console_info.partnerCode;
  } catch (e) {
    return undefined;
  }
};
/**
 * 是否为partnerCode是否为'telin', 'chief', 'harmony'中某一种。若是，返回partnerCode，否返回false
 * @function
 */

export var getCopywritingTag = function getCopywritingTag() {
  var hasCopywritingPartner = ['telin', 'chief', 'harmony'];

  try {
    var partnerCode = getPartnerCode();
    return partnerCode && hasCopywritingPartner.includes(partnerCode) ? partnerCode : 'zenlayer';
  } catch (e) {
    return false;
  }
};
/**
 * 获取主题
 * @function
 */

export var getThemes = function getThemes() {
  try {
    return window._console_info.consoleBranding.themes;
  } catch (e) {
    return ['light'];
  }
};
/**
 * 获取文案信息（名称&url），包括（使用条款、隐私政策、cookie声明）
 * @function
 */

export var getCopyrightInfo = function getCopyrightInfo() {
  try {
    var _window$_console_info;

    var info = [{
      name: t('FXdFXoowPknJ'),
      //使用条款
      url: window._console_info.legalDocuments.termsOfUseLink
    }, {
      name: t('lkwhISO3Z0ql'),
      //隐私政策
      url: window._console_info.legalDocuments.privacyNoticeLink
    }, {
      name: t('5WvfYfCi3Gae'),
      //Cookie 声明
      url: window._console_info.legalDocuments.cookieNoticeLink
    }];

    if (!!((_window$_console_info = window._console_info.legalDocuments.additionalFooterLinks) !== null && _window$_console_info !== void 0 && _window$_console_info.length)) {
      info = [].concat(_toConsumableArray(info), _toConsumableArray(window._console_info.legalDocuments.additionalFooterLinks.map(function (i) {
        return {
          name: getLocale() === 'zh' ? i.name_cn : i.name,
          url: i.link
        };
      })));
    }

    return info;
  } catch (e) {
    return [];
  }
};
export var getCompanyName = function getCompanyName() {
  try {
    return window._console_info.paymentSettings.companyName;
  } catch (e) {
    return '';
  }
};
/**
 * 获取汇款信息
 * @function
 */

export var getRemittanceContent = function getRemittanceContent() {
  try {
    return [{
      title: t('3LlNJqQcLeoT'),
      column: 3,
      children: [{
        name: t('B9OAT4hgXu9o'),
        //收款人账户
        data: window._console_info.paymentSettings.account,
        columnSpan: 3,
        info: t('XaYXbOG54IuX'),
        strong: true
      }, {
        name: t('n48kVzEhK3jD'),
        //银行行号
        data: window._console_info.paymentSettings.bankAccount
      }, {
        name: t('zeRppZebPl1Z'),
        //银行路由号码
        data: window._console_info.paymentSettings.bankCode
      }, {
        name: t('rngPf2P2yfjD'),
        //银行国际代码
        data: window._console_info.paymentSettings.swiftCode
      }].filter(function (i) {
        return !!i.data;
      })
    }, {
      title: t('7QpdS2z08L8c'),
      column: 3,
      children: [{
        name: t('YXjFOYhmZKtj'),
        //公司名称
        data: window._console_info.paymentSettings.companyName
      }, {
        name: t('m8WUwsLPNGJ8'),
        //公司地址
        data: window._console_info.paymentSettings.companyAddress
      }, {
        name: t('6kpL6lNts78h'),
        //收款银行
        data: window._console_info.paymentSettings.bank
      }, {
        name: t('OyRMofpzVani'),
        //收款人名称
        data: window._console_info.paymentSettings.name
      }].filter(function (i) {
        return !!i.data;
      })
    }];
  } catch (e) {
    return [];
  }
};
/**
 * 获取API文档url
 * @function
 */

export var getApiDocsUrl = function getApiDocsUrl() {
  if (getIsHarmonyPartner()) {
    return 'https://docs.console.harmonynetworks.net';
  }

  return getLocale() === 'zh' ? 'https://docs.console.zenlayer.com/api-reference/v/cn' : 'https://docs.console.zenlayer.com/api-reference';
};
/**
 * 获取BMC条款
 * @function
 */

export var getBmcAgreement = function getBmcAgreement(isChinese) {
  try {
    return window._console_info.legalDocuments.agreement[getProductInfoForAlias('bmc_instance').serviceSn + (isChinese ? '_cn' : '')].map(function (i) {
      return {
        name: getLocale() === 'zh' ? i.name_cn : i.name,
        url: i.link
      };
    });
  } catch (e) {
    return [];
  }
};
/**
 * 获取SDN条款
 * @function
 */

export var getSdnAgreement = function getSdnAgreement(isChinese) {
  try {
    return window._console_info.legalDocuments.agreement[getProductInfoForAlias('sdn_port').serviceSn + (isChinese ? '_cn' : '')].map(function (i) {
      return {
        name: getLocale() === 'zh' ? i.name_cn : i.name,
        url: i.link
      };
    });
  } catch (e) {
    return [];
  }
};
/**
 * 获取VM条款
 * @function
 */

export var getVmAgreement = function getVmAgreement(isChinese) {
  try {
    return window._console_info.legalDocuments.agreement[getProductInfoForAlias('vm_instance').serviceSn + (isChinese ? '_cn' : '')].map(function (i) {
      return {
        name: getLocale() === 'zh' ? i.name_cn : i.name,
        url: i.link
      };
    });
  } catch (e) {
    return [];
  }
};
/**
 * 获取VM国内条款
 * @function
 */

export var getCnVmAgreement = function getCnVmAgreement() {
  try {
    return window._console_info.legalDocuments.agreement[getProductInfoForAlias('vm_instance').serviceSn + '_cn'].map(function (i) {
      return {
        name: getLocale() === 'zh' ? i.name_cn : i.name,
        url: i.link
      };
    });
  } catch (e) {
    return [];
  }
};
/**
 * 获取ZEC条款
 * @function
 */

export var getZcsAgreement = function getZcsAgreement(isChinese) {
  try {
    return window._console_info.legalDocuments.agreement[getProductInfoForAlias('zec_instance').serviceSn + (isChinese ? '_cn' : '')].map(function (i) {
      return {
        name: getLocale() === 'zh' ? i.name_cn : i.name,
        url: i.link
      };
    });
  } catch (e) {
    return [];
  }
};
/**
 * 获取ZEC国内条款
 * @function
 */

export var getCnZcsAgreement = function getCnZcsAgreement() {
  try {
    return window._console_info.legalDocuments.agreement[getProductInfoForAlias('zec_instance').serviceSn + '_cn'].map(function (i) {
      return {
        name: getLocale() === 'zh' ? i.name_cn : i.name,
        url: i.link
      };
    });
  } catch (e) {
    return [];
  }
};
/**
 * 获取IPT条款
 * @function
 */

export var getIptAgreement = function getIptAgreement(isChinese) {
  try {
    return window._console_info.legalDocuments.agreement[getProductInfoForAlias('ipt_bandwidth').serviceSn + (isChinese ? '_cn' : '')].map(function (i) {
      return {
        name: getLocale() === 'zh' ? i.name_cn : i.name,
        url: i.link
      };
    });
  } catch (e) {
    return [];
  }
};
/**
 * 获取zga条款
 * @function
 */

export var getZgaAgreement = function getZgaAgreement(isChinese) {
  try {
    return window._console_info.legalDocuments.agreement[getProductInfoForAlias('gia_accelerator').serviceSn + (isChinese ? '_cn' : '')].map(function (i) {
      return {
        name: getLocale() === 'zh' ? i.name_cn : i.name,
        url: i.link
      };
    });
  } catch (e) {
    return [];
  }
};
/**
 * 获取PrimaryColor
 * @function
 */

export var getPrimaryColor = function getPrimaryColor() {
  try {
    return window._console_info.consoleBranding.primaryColor;
  } catch (e) {
    return undefined;
  }
};
/**
 * 获取SecondaryColor
 * @function
 */

export var getSecondaryColor = function getSecondaryColor() {
  try {
    return window._console_info.consoleBranding.secondaryColor;
  } catch (e) {
    return undefined;
  }
};
/**
 * 获取销售人员的联系方式
 * @function
 */

export var getContactUsSales = function getContactUsSales() {
  try {
    return window._console_info.salesSupportContacts.sales;
  } catch (e) {
    return undefined;
  }
};
/**
 * 获取技术支持的联系方式
 * @function
 */

export var getContactUsSupport = function getContactUsSupport() {
  try {
    return window._console_info.salesSupportContacts.support;
  } catch (e) {
    return undefined;
  }
};
/**
 * 获取请求缓存开关状态
 * @function
 */

export var getDisableFetchCache = function getDisableFetchCache() {
  try {
    var storageFlag = localStorage.getItem('disableFetchCache');

    if (storageFlag) {
      return storageFlag === 'true';
    }

    var windowFlag = window._console_info.disableFetchCache;

    if (windowFlag) {
      return windowFlag === true;
    }

    return false;
  } catch (e) {
    return false;
  }
};
export var getLanguages = function getLanguages() {
  try {
    var _window$_console_info2;

    return (_window$_console_info2 = window._console_info.consoleBranding.languages) !== null && _window$_console_info2 !== void 0 ? _window$_console_info2 : ['en'];
  } catch (e) {
    return ['en'];
  }
};